<template lang="html">
  <div class="login-popup tdf-popup zindex">
    <v-form v-model="valid" ref="formUniqueId">
      <!-- <v-text-field
        v-model="uniqueId"
        :rules="pinRules"
         :error-messages="errorMessage"
        :append-icon="e4 ? 'visibility' : 'visibility_off'" @click:append="() => (e4 = !e4)" :type="e4 ? 'text':'password'"
        :label="$translate('PIN')"
        required="required"
      ></v-text-field> -->
      <v-text-field
        v-model="mail"
        :rules="pinRules"
         :error-messages="errorMessage"
        :label="$translate('EMAIL')"
        required="required"
      ></v-text-field>
            <v-text-field
        v-model="password"
        :rules="pinRules"
         :error-messages="errorMessage"
        :append-icon="e4 ? 'visibility' : 'visibility_off'" @click:append="() => (e4 = !e4)" :type="e4 ? 'text':'password'"
        :label="$translate('PASSWORD')"
        required="required"
      ></v-text-field>

       <v-btn round :loading="loading" @click="submit">{{$translate('LOGIN')}}</v-btn>
       <v-btn round :disabled="loading" @click="$emit('close')">{{$translate('CANCEL')}}</v-btn>
    </v-form>
  </div>
</template>

<script>
import UserObject from "@/objects/UserObject.js";
import {
  mapGetters
} from "vuex";
import BaseComponent from '@/components/base/BaseComponent.vue';

export default {
  extends: BaseComponent,
  name: 'login-popup',
  methods: {
    submit() {
      this.errorMessage = [];
      if (this.$refs.formUniqueId.validate()) {
        this.loading = true;

        this.user = new UserObject(this.uniqueId, this.email, "u", this.password);
        this.loading = true;
        this.user.userlogin(
          response => {this.loggedSuccess(response)},
          this.loggedUnsuccessfull
        );
      }
    },
    loggedSuccess(response){
      this.loading = false;
      this.$emit('close');
      this.$router.push({
        name: 'Login',
        params: {
          uniqueId: this.userName,
          type: "u",
          account_id: this.$store.getters.getRegion
        }
      });
    },
    loggedUnsuccessfull(error){
      console.error('loggedUnsuccessfull',error);
      this.loading = false;
    },
  },

  data() {
    return {
      email: '',
      password: '',
      e4: false,
      uniqueId: '',
      pinRules: [
        v => !!v || 'Pin is required'
      ],
      errorMessage: [],
      loading: false,
      valid: true,
      user: null,
    }
  }
}
</script>

<style lang="scss">
.login-popup {
    max-width: 300px;
}
</style>
